// src/groups/PublicGroupView.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import GroupInfo from "./Groupinfo";
import Publicviewgroup from "./PublicGroupview";
import X from "../icon/closeicon";
import { resolveAvatarUrl, handleAvatarError } from "../../utils/profilePicUrl";
import "./groupdesign/GroupGuestView.css";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost/cool/my-app/backend";

function getDisplayName(member) {
  const full = [member.first_name, member.last_name].filter(Boolean).join(" ").trim();
  return full || member.username || "Member";
}

function getMemberRole(member) {
  return (member.role || member.typeofuser || "member").toUpperCase();
}

export default function PublicGroupView() {
  const { groupId } = useParams();
  const numericGroupId = Number(groupId);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("posts");
  const [posts, setPosts] = useState([]);
  const [likes, setLikes] = useState({});
  const [userLiked, setUserLiked] = useState({});
  const [repliesByPostId, setRepliesByPostId] = useState({});
  const [members, setMembers] = useState([]);

  const fetchPosts = async () => {
    if (!groupId) return;
    try {
      const res = await fetch(
        `${API_URL}/get_group_posts.php?group_id=${numericGroupId}`
      );
      const data = await res.json();
      if (data.success) {
        updateStateFromPosts(data.posts || []);
      }
    } catch (err) {
      console.error("Error fetching posts:", err);
    }
  };

  const fetchGroupMembers = async () => {
    try {
      const res = await fetch(
        `${API_URL}/get_group_members.php?group_id=${numericGroupId}`
      );
      const data = await res.json();
      if (data.success) setMembers(data.members || []);
    } catch (err) {
      console.error("Error fetching group members:", err);
    }
  };

  useEffect(() => {
    fetchPosts();
    if (groupId) fetchGroupMembers();
  }, [groupId]);

  const updateStateFromPosts = (newPosts) => {
    setPosts(newPosts);

    const likeCounts = {};
    const likedStatus = {};
    const repliesMap = {};

    newPosts.forEach((post) => {
      likeCounts[`post_${post.id}`] = post.like_count || 0;
      likedStatus[`post_${post.id}`] = post.user_liked || false;
      repliesMap[post.id] = post.replies || [];

      post.replies?.forEach((reply) => {
        likeCounts[`reply_${reply.id}`] = reply.like_count || 0;
        likedStatus[`reply_${reply.id}`] = reply.user_liked || false;
      });
    });

    setLikes(likeCounts);
    setUserLiked(likedStatus);
    setRepliesByPostId(repliesMap);
  };

  return (
    <div className="guest-group-page">
      <button
        type="button"
        className="guest-back-btn"
        onClick={() => navigate("/")}
        aria-label="Close"
      >
        <X />
      </button>

      <GroupInfo groupId={groupId} members={members} guestView />

      <div className="guest-tabs">
        <button
          type="button"
          className={activeTab === "posts" ? "active" : ""}
          onClick={() => setActiveTab("posts")}
        >
          Posts
        </button>
        <button
          type="button"
          className={activeTab === "members" ? "active" : ""}
          onClick={() => setActiveTab("members")}
        >
          Members
          {members.length > 0 ? ` · ${members.length}` : ""}
        </button>
      </div>

      <div className="guest-tab-panel">
        {activeTab === "posts" && (
          <Publicviewgroup
            groupId={numericGroupId}
            user={null}
            posts={posts}
            likes={likes}
            userLiked={userLiked}
            repliesByPostId={repliesByPostId}
            onReplyAdded={() => {}}
            onLikeToggle={() => {}}
            onRefresh={fetchPosts}
          />
        )}

        {activeTab === "members" && (
          <div>
            <div className="guest-members-header">
              <h4 className="guest-members-title">Group Members</h4>
              <p className="guest-members-subtitle">
                People who belong to this group
              </p>
            </div>

            {members.length === 0 ? (
              <p className="guest-members-empty">No members yet.</p>
            ) : (
              <ul className="guest-member-list">
                {members.map((member) => {
                  const role = getMemberRole(member);
                  const isAdmin = role === "ADMIN";
                  return (
                    <li key={member.id} className="guest-member-card">
                      <img
                        className="guest-member-avatar"
                        src={resolveAvatarUrl(member, API_URL)}
                        alt={member.username}
                        onError={handleAvatarError}
                      />
                      <div className="guest-member-body">
                        <div className="guest-member-name">
                          {getDisplayName(member)}
                        </div>
                        <div className="guest-member-meta">
                          @{member.username}
                          {member.email ? ` · ${member.email}` : ""}
                        </div>
                        {(member.typeofuser || member.country) && (
                          <div className="guest-member-extra">
                            {[member.typeofuser, member.country]
                              .filter(Boolean)
                              .join(" · ")}
                          </div>
                        )}
                      </div>
                      <span
                        className={`guest-member-role${isAdmin ? " admin" : ""}`}
                      >
                        {role}
                      </span>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
